import Axios from 'axios';
import CONSTANTS from './constants';
import router from '@/router';
import useUserStore from '@/store/modules/user';
import util from '@/utils';
import { ElMessage } from 'element-plus';

const axios = Axios.create({
  timeout: 60000,
  headers: { 'X-Custom-Header': 'foobar' },
  baseURL: process.env.VUE_APP_URL,
});

// 添加请求拦截器
axios.interceptors.request.use(
  function (config) {
    const token = util.getLocalStorage(CONSTANTS.TOKEN);
    token && (config.headers.Authorization = 'Bearer ' + token);
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  async response => {
    const type = Object.prototype.toString.call(response.data);
    if (type === '[object Blob]') {
      const data = response.data;
      try {
        const text = await data.text();
        const d = JSON.parse(text);
        if (d.code === 500) {
          ElMessage.warning(d.msg);
          return d;
        }
        return data;
      } catch (e) {
        return data;
      }
    } else {
      if (response.status == 200) {
        if (response.data.code === 401) {
          const userStore = useUserStore();
          userStore.clearStorage();
          router.replace('/login');
          ElMessage.warning(response.data.msg);
        } else if (response.data.code !== 200) {
          ElMessage.warning(response.data.msg);
        }
        return response.data;
      } else {
        return response.data;
      }
    }
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default axios;
